module.exports = __webpack_public_path__ + "static/img/A61831_4.9e54996.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeContent/reportImage/A61831_4.png
// module id = 8z6S
// module chunks = 1